<!-- The Modal-->
<div class="modal" id="modalNewSubject">
  <div class="modal-dialog">
    <div class="modal-content">

      <!-- Modal Header -->
      <div class="modal-header gold-bg">
        <h4 class="modal-title">
          <span class="glyphicon glyphicon-lock"></span>
          Add New Subject for {{level_country_name}} {{level_name}}
          </h4>
          <button type="button" class="btn btn-danger" (click)="closeModal()">&times;</button>
      </div>

      <!-- Modal body -->
<form [formGroup] = "myForm" (ngSubmit)="form_submit()" class="form" enctype="multipart/form-data" >



<div class="form-group row mt-2" [ngClass]="{error:f.syllabus.errors && f.syllabus.touched}">
  <label for="syllabus" class='control-label col-sm-3'>Syllabus<span class="required-asteric">*</span></label>
      <div class="col-sm-8">
          <select class="form-control" id="syllabus"   formControlName="syllabus">
              <option *ngFor="let syllabus of syllabusList" [value]="syllabus['id']">{{syllabus['syllabuscode']}} {{syllabus['description']}}</option>
          </select>
          <div *ngIf="f.syllabus.errors && f.syllabus.touched" style="color:red;float: left;width: 100%;background: #ff000014;margin-top: 10px;padding: 10px 2px 0px 1px;">
              <ul>
                  <li>Syllabus is required.</li>
              </ul>
          </div>
      </div>
</div>
<div class='col-sm-12 text-center my-2'>
  <button  type="submit" class="btn btn-primary margin-50-right">Save</button>
  <button type="button" class="btn btn-danger" (click)="closeModal()">Close</button>
 </div>
</form>
</div>
</div>
</div>
